// extracted by mini-css-extract-plugin
export default {"container":"Menu_container__XwZjs","nav":"Menu_nav__siVV1","logoLink":"Menu_logoLink__sGkIO"};